function iniciaSesion( respuesta ) {
    $( '#loginForm .button' ).removeClass( 'skeleton' );
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        seteaSesion( 'usuarioId', datos.usuario.usuarioId );
		seteaSesion( 'rolId', datos.usuario.rolId );
		seteaSesion( 'avatar', datos.usuario.avatar );
		seteaSesion( 'usuarioNombre', datos.usuario.nombre );
		seteaSesion( 'usuarioData', JSON.stringify( datos.usuario ) );
		alerta( 'Sesion iniciada con éxito', 'success', false );
		setTimeout( () => manda( '/' ), 1000 );
    } else {
        let msg = idioma == 'ES' ? 'Usuario o contraseña incorrectos' : 'Incorrect username or password';
        alerta( msg, 'error', false );
    }
}
function registraSesion( respuesta ) {
    $( '#registroForm .button' ).removeClass( 'skeleton' );
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        seteaSesion( 'usuarioId', datos.usuario.usuarioId );
		seteaSesion( 'rolId', datos.usuario.rolId );
		seteaSesion( 'avatar', datos.usuario.avatar );
		seteaSesion( 'usuarioNombre', datos.usuario.nombre );
		seteaSesion( 'usuarioData', JSON.stringify( datos.usuario ) );
        if ( $( 'input[name="tipoCuenta"]:checked' ).val() == 2 ) {
            var msg = idioma == 'ES' ? 'Solicitud de cuenta validador creada con éxito. En breve nos pondremos en contacto contigo para validar tu cuenta, de momento tendras acceso general hasta recibir aprobación.' : 'Your account validation request was successfully created. We will contact you shortly to validate your account; in the meantime, you will have general access until approval is received.';
            alertaCallBack( msg, 'success', function() { manda( '/' ) } );
        } else {
            var msg = idioma == 'ES' ? 'Cuenta creada con éxito' : 'Account created successfully';
		    alertaCallBack( msg, 'success', function() { manda( '/' ) } );
        }
    } else if ( datos.status == 'Repetido' ) {
        let msg = idioma == 'ES' ? 'El usuario ya existe' : 'The user already exists';
        alerta( msg, 'error', false );
    } else {
        let msg = idioma == 'ES' ? 'Usuario o contraseña incorrectos' : 'Incorrect username or password';
        alerta( msg, 'error', false );
    }
}
function logout() {
    ajaxRequest( false, 'POST', {}, 'api/account/logout', cierraSesion );
}
function limpiaSesion() {
    borraSesion( 'usuarioId' );
    borraSesion( 'rolId' );
    borraSesion( 'avatar' );
    borraSesion( 'usuarioNombre' );
    borraSesion( 'usuarioData' );
}
function cierraSesion() {
    limpiaSesion();
    manda( '/' );
}
function googleInicia( userId, nombre, email ) {
    ajaxRequest( false, 'POST', { 'googleId' : userId, 'nombre' : nombre, 'email': email }, 'api/account/google', iniciaSesion );
}
function iniciaGoogle() {
	var provider = new firebase.auth.GoogleAuthProvider();
	firebase.auth().signInWithPopup( provider ).then( ( result ) => {
		var credential = result.credential;
		var token = credential.accessToken;
    	var user = result.user;
    	console.log( result );
    	var parametros = {
    		'nombre': user.displayName,
    		'email': user.email,
    		'foto': user.photoURL,
    		'uid': user.uid
    	}
        ajaxRequest( false, 'POST', parametros, 'api/account/google', iniciaSesion );
	} ).catch( ( error ) => {
		var errorCode = error.code;
		var errorMessage = error.message;
		var email = error.email;
		var credential = error.credential;
		console.log( error );
	} );
}